import React from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

/**
 * Mobile's Dropdown for sorting powerplants.
 * @copyright Optimum Tracker
 * @author wkoffi
 */

class SortingBarMobile  extends React.Component
{	
	render()
	{  
        const nameSorting = 
        <div className="sorting-bar-hover">
            <img
                src="/images/logo/arrows.png"
                width="20"
                height="20"
                className="logo-responsive wind"
                alt="Sorting arrows"
            />
            <img
                src="/images/logo/texts.png"
                width="18"
                height="18"
                className="logo-responsive wind"
                alt="Sorting by name"
            />
        </div>;

        const powerSorting = 
        <div className="sorting-bar-hover">
            <img
                src="/images/logo/sunny.png"
                width="20"
                height="20"
                className="logo-responsive wind"
                alt="Sorting by power"
                />
            <img
                src="/images/logo/arrows.png"
                width="20"
                height="20"
                className="logo-responsive wind"
                alt="Sorting arrows"
            />
            <span className="font-sorting-bar-text" href="#">Power</span>
        </div>;

        const trackersOk = 
        <div>
            <img
                src="/images/logo/panel-green.png"
                width="20"
                height="20"
                className="logo-responsive wind"
                alt="Sorting by Nb trackers Ok"
            />
            <img
                src="/images/logo/arrows.png"
                width="15"
                height="15"
                className="logo-responsive wind arrows"
                alt="Sorting arrows"
            />
            <span className="font-sorting-bar-text">Trackers Ok</span>
        </div>;

        const options =  [
            { value: "name", label: nameSorting },
            { value: "power", label: powerSorting },
            { value: "percentAuto", label: trackersOk }
        ];
        
        return (
                <div>
                    <Dropdown options={options} placeholder="Sort options" onChange={(e) => this.props.setSorting(e.value)}/>
                </div>
            );
	}
}

SortingBarMobile.defaultProps = {
    setSorting: function(){}
};

export default SortingBarMobile;